export default "__VITE_ASSET__rhZQCodR__"